(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vizo-atmosphere"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motions = new Set();
  const seen = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (reduced.matches || !entry.target.animate) return;
      const animation = entry.target.animate([{opacity:.65,transform:'translateY(15px)'},{opacity:1,transform:'translateY(0)'}],{duration:220,easing:'cubic-bezier(.2,.7,.2,1)'});
      motions.add(animation);
      animation.onfinish = () => motions.delete(animation);
    });
  },{threshold:.12}) : null;
  function init() {
    document.querySelectorAll('.vizo-case,.vizo-reason,.vizo-step,.vizo-brand-panel,.vizo-invitation h2').forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      if (observer && !reduced.matches) observer.observe(el);
    });

  }
  reduced.addEventListener('change',() => {
    if (!reduced.matches) return;
    motions.forEach(animation => animation.cancel());
    motions.clear();
    if (observer) observer.disconnect();
  });
  init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vizo-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set();
  let paused = reduced.matches;
  try { paused = paused || sessionStorage.getItem('vizo-motion') === 'paused'; } catch (_) {}
  function animate(el,frames,options) {
    if (paused || reduced.matches || !el.animate) return;
    const a = el.animate(frames,options);active.add(a);a.onfinish=()=>active.delete(a);
  }
  function sync() {
    document.body.classList.toggle('vizo-motion-paused',paused || reduced.matches);
    document.querySelectorAll('.vizo-motion-toggle').forEach(b=>{b.setAttribute('aria-pressed',String(paused || reduced.matches));});
    if (paused || reduced.matches) { active.forEach(a=>a.cancel());active.clear(); }
  }
  const observed = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries=>entries.forEach(e=>e.target.classList.toggle('vizo-motion-visible',e.isIntersecting)),{threshold:.05}) : null;
  function init() {
    document.querySelectorAll('#agency-attention,.vizo-platforms,.vizo-location,.vizo-about-home,.vizo-benefits,.vizo-invitation').forEach(el=>{if(observed.has(el))return;observed.add(el);if(observer)observer.observe(el);});
    document.querySelectorAll('.vizo-motion-toggle').forEach(b=>{
      if(b.dataset.bound)return;b.dataset.bound='true';
      b.addEventListener('click',()=>{paused=!(paused || reduced.matches);try{sessionStorage.setItem('vizo-motion',paused?'paused':'on');}catch(_){}sync();});
    });
    document.querySelectorAll('.vizo-platforms').forEach(section=>{
      if(section.dataset.tabsReady)return;
      const list=section.querySelector('[role=tablist]');
      const tabs=[...list.querySelectorAll('[role=tab]')];
      const panels=[...section.querySelectorAll('.vizo-platform-panel')];
      function select(index,focus=false) {
        tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;panels[i].setAttribute('role','tabpanel');panels[i].tabIndex=0;});
        animate(panels[index],[{opacity:.5,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:140,easing:'ease-out'});
        if(focus)tabs[index].focus();
      }
      tabs.forEach((tab,i)=>{
        tab.addEventListener('click',()=>select(i));
        tab.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();select(n,true);});
      });
      select(0);list.hidden=false;section.dataset.tabsReady='true';
    });
    document.querySelectorAll('.vizo-benefit').forEach(detail=>{
      if(detail.dataset.bound)return;detail.dataset.bound='true';
      detail.addEventListener('toggle',()=>{if(detail.open)animate(detail.querySelector('.vizo-benefit-body'),[{opacity:.4,transform:'translateY(-5px)'},{opacity:1,transform:'translateY(0)'}],{duration:140,easing:'ease-out'});});
    });
    sync();
  }
  reduced.addEventListener('change',sync);
  document.addEventListener('visibilitychange',()=>document.body.classList.toggle('vizo-page-hidden',document.hidden));
  document.addEventListener('shopify:section:load',init);
  init();
})();
  } catch(e) { console.error(e); }
})();

})();
